import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f5a269"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "finished-flag"
}
const _hoisted_2 = {
  key: 2,
  class: "progress-flag"
}
const _hoisted_3 = { class: "card__content" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "card__information" }
const _hoisted_6 = {
  key: 0,
  class: "decoins"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-ls-module": "progressBar",
  role: "progressbar",
  "aria-valuenow": "60"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoPlayButton = _resolveComponent("VideoPlayButton")!
  const _component_ButtonComment = _resolveComponent("ButtonComment")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToCourse()))
  }, [
    (_ctx.course.haveCertification)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onMousemove: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          title: "Certificado",
          class: "card__certificate"
        }, null, 32))
      : _createCommentVNode("", true),
    (_ctx.course.statusCourse.finished)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Concluído"))
      : _createCommentVNode("", true),
    (_ctx.course.statusCourse.progress)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Em andamento"))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(['card__img', { finished: _ctx.course.statusCourse.finished }])
    }, [
      (_ctx.course.hasNewContent)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            onMousemove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            class: "card__new_contents"
          }, null, 32))
        : _createCommentVNode("", true),
      (_ctx.isNewCourse())
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            onMousemove: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            class: "card__release_course"
          }, null, 32))
        : _createCommentVNode("", true),
      (_ctx.course.introductoryContent)
        ? (_openBlock(), _createBlock(_component_VideoPlayButton, {
            key: 2,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openIntroductoryContent())),
            class: "video-play-button"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: "card__title",
        title: _ctx.course.title,
        onMousemove: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, _toDisplayString(_ctx.course.title), 41, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.course.haveDecoins && _ctx.isDecolaTemplate())
          ? (_openBlock(), _createElementBlock("span", _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.course.duration)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onMousemove: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
                class: "card__duration",
                title: "Duração"
              }, _toDisplayString(_ctx.formattedDuration(_ctx.course.duration)), 33))
            : _createCommentVNode("", true),
          (Number(_ctx.course.rating) > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                onMousemove: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                class: "card__rating",
                title: "Avaliação"
              }, _toDisplayString(parseFloat(_ctx.course.rating.toString()).toFixed(1)), 33))
            : _createCommentVNode("", true)
        ]),
        (_ctx.course.haveComments)
          ? (_openBlock(), _createBlock(_component_ButtonComment, {
              key: 1,
              class: "card__comments",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openComment()))
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_7
    ])
  ]))
}